<script>
    import {Bar, mixins} from 'vue-chartjs'

    const {reactiveProp} = mixins

    export default {
        name: 'chart-bar',
        extends: Bar,
        mixins: [reactiveProp],
        props: {
            options: {
                type: Object,
                default: () => ({})
            }
        },
        mounted() {
            this.renderChart(this.chartData, Object.assign({}, this.options, {responsive: true}))
        }
    }
</script>
